import gql from "graphql-tag";

export const GET_WEBTOONS = gql`
  query webToons($limit: Int, $sort: String) {
    webToons(limit: $limit, sort: $sort) {
      id
      title
      feat_image {
        url
      }
      create_date
    }
  }
`;

// export const GET_WEBTOON_BY_ID = gql`
//   query webToon($id: ID!) {
//     webToon(id: $id) {
//       id
//       title
//       webtoon_image {
//         id
//         image {
//           url
//         }
//       }
//       create_date
//     }
//   }
// `;

export const GET_WEBTOON_BY_ID = gql`
  query webToon($id: ID!) {
    webToon(id: $id) {
      id
      title
      feat_image {
        url
      }
      webtoon {
        id
        url
      }
      create_date
      web_toons_program {
        id
      }
    }
  }
`;

export const GET_WEBTOON_MENU_IMG = gql`
  query webToonsPrograms($limit: Int, $sort: String) {
    webToonsPrograms(limit: $limit, sort: $sort) {
      id
      title
      feat_img {
        url
      }
      web_toons {
        id
        title
      }
      created_at
    }
  }
`;

export const GET_WEBTOON_PROGRAM_BY_ID = gql`
  query webToonsProgram($id: ID!) {
    webToonsProgram(id: $id) {
      id
      title
      feat_img {
        url
      }
      web_toons {
        id
        title
        feat_image {
          url
        }
      }
      created_at
    }
  }
`;

export const GET_WEBTOON_BY_PROGRAM_ID = gql`
  query webToons($where: JSON, $sort: String) {
    webToons(where: $where, sort: $sort) {
      id
      title
      created_at
      feat_image {
        url
      }
      web_toons_program {
        id
      }
    }
  }
`;

export const GET_WEBTOON_NAVIGATION_BY_PROGRAM_ID = gql`
  query webToons($where: JSON, $sort: String, $limit: Int) {
    webToons(where: $where, sort: $sort, limit: $limit) {
      id
      title
      created_at
      feat_image {
        url
      }
    }
  }
`;
